import APIService from '@/services/APIService';
import CRUDFactory from '@/services/CRUDFactory';

export default {
  ...CRUDFactory('/organizations/teachers', APIService),

  attachCourators(courseId, data) {
    return APIService.post(`/curators/courses/${courseId}/attach-curators`, data);
  },

  detachCourators(courseId, data) {
    return APIService.post(`/curators/courses/${courseId}/detach-curators`, data);
  },
};
